// unit types (short: 'km', long: 'kilometers')
export const SHORT = 'short'
export const LONG = 'long'

// distance, elevation
export const KM = 'km'
export const KILOMETER = 'kilometer'
export const KILOMETERS = 'kilometer'
export const MI = 'mi'
export const MILE = 'mile'
export const MILES = 'mile'
export const FT = 'ft'
export const FOOT = 'ft'
export const FEET = 'foot'
export const Y = 'y'
export const YARD = 'yard'
export const YARDS = 'yard'
export const M = 'm'
export const METER = 'meter'
export const METERS = 'meter'

// energy
export const KCAL = 'kcal'
export const KILOCALORIE = 'kilocalorie'
export const KILOCALORIES = 'kilocalorie'
export const KJ = 'kj'
export const KILOJOULE = 'kilojoule'
export const KILOJOULES = 'kilojoule'
export const JOULES = 'joules'

// systems
export const METRIC = 'metric'
export const IMPERIAL = 'imperial'
export const HYBRID = 'hybrid'

// duration
export const S = 's'
export const SECOND = 'second'
export const SECONDS = 'second'
export const MIN = 'min'
export const MINUTE = 'minute'
export const MINUTES = 'minute'
export const H = 'h'
export const HOUR = 'hour'
export const HOURS = 'hour'
export const D = 'd'
export const DAY = 'day'
export const DAYS = 'day'
export const WK = 'wk'
export const WEEK = 'week'
export const WEEKS = 'week'
export const MO = 'mo'
export const MONTH = 'month'
export const MONTHS = 'month'
export const YR = 'yr'
export const YEAR = 'year'
export const YEARS = 'year'

// speed
export const FPS = 'fps'
export const FEET_PER_SECOND = 'feet_per_second'
export const MPH = 'mph'
export const MILES_PER_HOUR = 'miles_per_hour'
export const KPH = 'kph'
export const KILOMETERS_PER_HOUR = 'kilometers_per_hour'
export const MPS = 'mps'
export const METERS_PER_SECOND = 'meters_per_second'
export const KNOTS = 'knots'

// pace
export const MKM = 'mkm'
export const MMI = 'mmi'
export const MINUTE_KM = 'minute_km'
export const MINUTE_MI = 'minute_mi'
export const SECOND_KM = 'second_km'
export const SECOND_MI = 'second_mi'

// heart rate
export const BPM = 'bpm'
export const HEART_RATE = 'heartrate'
